import { useState, useEffect, useRef } from 'react';

/**
 * A hook that persists state across page refreshes, but resets 
 * to default when navigating from a different page/tab.
 */
export function useStickyState(defaultValue, key) {
  const [state, setState] = useState(() => {
    // Check if the page load is a manual refresh (reload)
    const navEntries = window.performance.getEntriesByType("navigation");
    const isRefresh = navEntries.length > 0 && navEntries[0].type === 'reload';
    
    const savedValue = sessionStorage.getItem(key);

    // If it's a refresh and we have data, use the "sticky" value
    if (isRefresh && savedValue !== null) {
      try {
        return JSON.parse(savedValue);
      } catch (e) {
        return savedValue; // Fallback for non-JSON strings
      }
    }

    // Default: It's a fresh navigation, use provided default
    return defaultValue;
  });

  // Sync state to sessionStorage whenever it changes
  useEffect(() => {
    sessionStorage.setItem(key, JSON.stringify(state));
  }, [key, state]);

  return [state, setState];
}